import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { environment } from 'src/environments/environment';

export const cookieConsentConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.web_url.split('://')[1].split(':')[0],
  },
  position: 'bottom-right',
  theme: 'block',
  palette: {
    popup: {
      background: '#000000',
      text: '#ffffff',
      link: '#ffffff',
    },
    button: {
      background: '#7f7873',
      text: '#000000',
      border: 'transparent',
    },
  },
  type: 'info',
  content: {
    message: 'This website uses cookies to ensure you get the best experience on our website.',
    dismiss: 'Got it!',
    deny: 'Refuse cookies',
    link: 'Learn more',
    href: environment.web_url + '/cookie-policy',
    policy: 'Cookie Policy',
  },
};
